import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Skills.css';

const Skills = () => {
    return (
        <div className='skills-gap'>
           <Container className='skills-conteiner'>
                <div className='services-dot'>
                    <h2>MY SKILLS</h2>
                    <h3>.</h3>
                </div>
                <p className='serv-p'>I skill gain</p>
                <Row>
                    <Col lg={6} md={6} sm={12}>
                        <div className='mt-4 skill-border'>
                            <div className='d-flex mt-2'>
                                <div className='circular-progress mx-5'>
                                    <h4>88%</h4>
                                </div>

                                <div className='mx-2 m-3'>
                                    <p className='fw-bold coursor develop'>Frontend Development</p>
                                </div>
                            </div>

                            <div className='d-flex'>
                               <div className='circular-progress mx-5'>
                                   <h4>79%</h4>
                               </div>
                               <div className='mx-2 m-3'>
                                   <p className='fw-bold coursor develop'>Full-Stack Development</p>
                               </div>
                           </div>

                            <div className='d-flex'>
                               <div className='circular-progress mx-5'>
                                   <h4>90%</h4>
                               </div>
                               <div className='mx-2 m-3'>
                                   <p className='fw-bold coursor develop'>UI/Ux Design</p>
                               </div>
                           </div>
                        </div>
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                        
                        <Row>
                            <Col lg={3} md={3} sm={6}>
                            <div className='mt-4'>
                                <div>
                                <h6 className='progressText'>HTML5</h6>
                                <div className="progress">
                                    <div className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width: '90%', height: '130%'}}>
                                    </div>
                                </div>
                            </div>

                            <div className='my-3'>
                                <h6 className='progressText'>CSS3</h6>
                                <div className="progress">
                                    <div className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width: '90%', height: '130%'}}>
                                    </div>
                                </div>
                            </div>


                            <div>
                                <h6 className='progressText'>JavaScript</h6>
                                <div className="progress">
                                    <div className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width: '85%', height: '130%'}}>
                                    </div>
                                </div>
                            </div>


                            <div className='my-3'>
                                <h6 className='progressText'>ReactJS</h6>
                                <div className="progress">
                                    <div className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width: '83%', height: '130%'}}>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <h6 className='progressText'>Bootstrap</h6>
                                <div className="progress">
                                    <div className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width: '95%', height: '130%'}}>
                                    </div>
                                </div>
                            </div> 
                                </div>
                        
                            </Col>

                            <Col lg={3} md={3} sm={6}>
                            <div className='progress-right mt-4'>
                                <div>
                                    <h6 className='progressText'>ExpressJS</h6>
                                    <div className="progress">
                                         <div className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width: '80%',height: '130%'}}>
                                         </div>
                                     </div>
                                </div>

                                <div className='my-3'>
                                    <h6 className='progressText'>Tailwind</h6>
                                    <div className="progress">
                                         <div className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width: '83%',height: '130%'}}>
                                         </div>
                                     </div>
                                </div>
                                
                                <div>
                                    <h6 className='progressText'>NodeJS</h6>
                                    <div className="progress">
                                         <div className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width: '87%',height: '130%'}}>
                                         </div>
                                     </div>
                                </div>


                                <div className='my-3'>
                                    <h6 className='progressText'>MongoDB</h6>
                                    <div className="progress">
                                         <div className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width: '80%',height: '130%'}}>
                                         </div>
                                     </div>
                                </div>
 
                                 <div className='my-3'>
                                    <h6 className='progressText'>MaterialUI</h6>
                                    <div className="progress">
                                         <div className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{width: '75%',height: '130%'}}>
                                         </div>
                                     </div>
                                </div>

                         </div>
                            </Col>
                        </Row>
                        
                    </Col>
                </Row>
           </Container>
        </div>
    );
};

export default Skills;